import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { BsArrowLeft } from "react-icons/bs";
import { ISubject } from "common/types";

interface LessonDurationSelectionProps {
  subject: ISubject;
  onDurationSelect: (minutes: number, price: number) => void;
  onBack: () => void;
}

function LessonDurationSelection({
  subject,
  onDurationSelect,
  onBack,
}: LessonDurationSelectionProps) {
  const getDurationOptions = () => {
    if (
      subject.prices &&
      Array.isArray(subject.prices) &&
      subject.prices.length > 0
    ) {
      return subject.prices.map((priceItem) => ({
        minutes: priceItem.duration,
        price: Number(priceItem.price),
      }));
    }

    // Fallback if no prices are defined or prices is not in expected format
    return [
      { minutes: 60, price: 25 },
      { minutes: 90, price: 37 },
      { minutes: 120, price: 48 },
    ];
  };

  const durationOptions = getDurationOptions();

  return (
    <Container className="mt-4">
      <div className="d-flex align-items-center mb-4">
        <BsArrowLeft
          className="mr-2 lessons-cursor-pointer"
          size={24}
          onClick={onBack}
        />
        <h3 className="ml-3 mb-0">Odaberite trajanje poduka: {subject.name}</h3>
      </div>

      <Row className="justify-content-center">
        {durationOptions.map((option) => (
          <Col md={4} key={option.minutes} className="mb-4">
            <Card
              className="h-100 lessons-cursor-pointer shadow-sm lessons-duration-card"
              onClick={() => onDurationSelect(option.minutes, option.price)}
            >
              <Card.Body className="text-center p-4 duration-card-body">
                <div>
                  <h3 className="duration-text">{option.minutes} minuta</h3>
                </div>
                <div className="lessons-price-tag mt-auto">
                  <h4>{Number(option.price).toFixed(2)} €</h4>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default LessonDurationSelection;
